export class Theme {
    //TODO: remove once old theme is gone
    private newBreakpoints: ThemeBreakpoints;

    constructor(
      public colors: ThemeColors,
      breakpoints: ThemeBreakpoints,
      public typography: ThemeTypographies
    ) {
      this.newBreakpoints = breakpoints;
    }
  
    breakpoint(size: keyof ThemeBreakpoints, direction: 'up' | 'down') {
      const up = direction === 'up';
      const minMax = up ? 'min' : 'max';
      const width = this.newBreakpoints[size] - (up ? 0 : 1);
      return (content: string) => `
        @media only screen and (${minMax}-width: ${width}px) {
          ${content}
        }
      `;
    }
  
    // Define any other utility functions here
  }
  
  export interface ThemeColors {
    colorMode: 'light' | 'dark'; // Whether or not the theme is light mode or dark mode
    base: ThemeColor; // The base color scheme/page background color
    primary: ThemeColor;
    secondary: ThemeColor;
    tertiary?: ThemeColor;
    accent?: ThemeColor;
    shade?: string[];
    [key: string]: ThemeColor | any; // Let people extend the base interface with whatever they want
  }
  
  export interface ThemeColor {
    main: string; // Main color
    light?: string; // Lighter variant
    dark?: string; // Darker variant
    hover?: string; // Hover/focus variant
    text: string; // Text color (must pass accessibility contrast ratio w/main)
    [key: string]: string | any; //custom named color
  }
  
  export interface ThemeBreakpoints {
    xs: number; // 0
    sm: number;
    md: number;
    lg: number;
    xl: number;
  }
  
  export interface ThemeTypographies {
    fontFamily: Record<string, string>; // Record of font families, i.e. { NoirPro: '"Noir Pro", Arial, Helvetica, sans-serif' }
    body1: ThemeTypography;
    body2?: ThemeTypography; 
    body3?: ThemeTypography;
    legal: ThemeTypography;
    button: ThemeTypography;
    h1: ThemeTypography;
    h2: ThemeTypography;
    h3: ThemeTypography;
    h4: ThemeTypography;
    h5: ThemeTypography;
    h6: ThemeTypography;
    [key: string]: ThemeTypography | any; //custom named color
  }
  
  export interface ThemeTypography {
    fontSize: {
      xs: string,
      sm?: string,
      md?: string,
      lg?: string,
      xl?: string,
    }
    lineHeight: {
      xs: string,
      sm?: string,
      md?: string,
      lg?: string,
      xl?: string,
    };
    fontWeight: string;
    [key: string]: any;
  }  